
import NavigationView from './views/NavigationView.vue';

import { defineComponent } from 'vue';

export default defineComponent({
	components: { NavigationView },
	name: 'App',
});
